/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  TunneledMcpServer,
  TunneledMcpServer$inboundSchema,
} from "./tunneledmcpserver.js";

/**
 * Created tunneled MCP server plus the one-time tunnel key
 */
export type CreateTunneledMcpServerResult = {
  /**
   * A customer-hosted MCP server connected through a tunnel
   */
  server: TunneledMcpServer;
  /**
   * Plaintext tunnel key. Only returned at creation time.
   */
  tunnelKey: string;
};

/** @internal */
export const CreateTunneledMcpServerResult$inboundSchema: z.ZodMiniType<
  CreateTunneledMcpServerResult,
  unknown
> = z.pipe(
  z.object({
    server: TunneledMcpServer$inboundSchema,
    tunnel_key: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "tunnel_key": "tunnelKey",
    });
  }),
);

export function createTunneledMcpServerResultFromJSON(
  jsonString: string,
): SafeParseResult<CreateTunneledMcpServerResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateTunneledMcpServerResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateTunneledMcpServerResult' from JSON`,
  );
}
